<template>
  <div class="mt-n10 pt-0">
    <v-navigation-drawer
      v-model="drawer"      
      app
      right
      width="550"
      temporary
      hide-overlay
    >
      <v-toolbar
        color="hrissecondary" 
        dark
      >
        <v-toolbar-title class="white--text">
          Advanced Filter
        </v-toolbar-title>
      </v-toolbar>
      <v-container> 
        <v-row no-gutters>
          <v-col cols="12">
            <v-autocomplete
              v-model="selectedStatuses"
              :items="statuses"              
              label="Status"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
              small-chips
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="selectedDepartments"
              :items="departments"              
              label="Current Department"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
              small-chips
              clearable
            />
          </v-col>
              
          <v-col cols="12">
            <v-autocomplete
              v-model="selectedPolicies"
              :items="jobGroupPolicies"              
              label="Policy"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
              small-chips
              clearable
            />
          </v-col>

          <v-col cols="12">
            <v-autocomplete
              v-model="selectedCompanies"
              :items="companies"              
              label="Company"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
              small-chips
              clearable
            />
          </v-col>
          <v-col cols="12">
            <v-autocomplete
              v-model="selectedClaimTypes"
              :items="claimTypes"              
              label="Claim Type"
              item-text="name"
              item-value="id"
              hide-no-data
              hide-selected
              chips
              multiple
              deletable-chips
              small-chips
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            class="mt-8"
          >
            <v-menu
              v-model="dateRangeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :value="dateRangeDisplay"
                  label="Payment Date"  
                  readonly
                  class="label-position"
                  prepend-icon="mdi-calendar"
                  placeholder="Select the date range for payment date"
                  clearable
                  v-on="on"
                  @click:clear="dateRange = []"
                />
              </template>
              <v-date-picker
                v-model="dateRange"
                :max="today"
                range
                no-title
                scrollable
                :allowed-dates="allowedDatesFor(dateRange)"
              />
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            class="text-center mb-5 pr-5"
            style="position: fixed; bottom: 0;"
          >
            <v-btn
              block
              color="hrissecondary"
              class="white--text"
              @click="selectedClaimRequests = []; loadClaims()"
            >
              Search
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-container
      class="hidden-sm-and-down"
      fluid
    >
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-toolbar
              flat
              color="white"
            >
              <v-col cols="3">
                <v-text-field
                  ref="searchInput"
                  v-model="searchInput"
                  autofocus
                  append-icon="search"
                  placeholder="Search by name or reference number"
                  single-line
                  hide-details
                  clearable
                  class="py-0"
                />
              </v-col>
              
              <v-col cols="3">
                <v-menu
                  v-model="claimCycleRangeMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="claimCycleRangeDisplay"
                      label="Claim Cycle Date Range"  
                      readonly
                      class="label-position mt-5 py-0"
                      prepend-icon="mdi-calendar"
                      placeholder="Select the date range for claim cycle"
                      v-on="on"
                    />
                  </template>
                  <v-date-picker
                    v-model="claimCycleDateRange"
                    range
                    no-title
                    scrollable
                    :allowed-dates="allowedDatesFor(claimCycleDateRange)"
                    @change="loadClaims"
                  />
                </v-menu>
              </v-col>

              <v-spacer />
              
              <v-tooltip
                v-if="isFiltering"
                content-class="bottom"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn   
                    text
                    icon           
                    color="primary"
                    v-on="on"
                    @click="clearFilter"
                  >
                    <v-icon 
                      color="error"                      
                      medium
                    >
                      mdi-close
                    </v-icon>
                  </v-btn> 
                </template>
                <span>Clear filter</span>
              </v-tooltip>

              <v-tooltip
                content-class="bottom"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn   
                    text
                    icon           
                    color="primary"
                    v-on="on"
                    @click.stop="drawer = true"
                  >
                    <v-icon 
                      v-if="isFiltering" 
                      medium
                    >
                      filter_list_alt
                    </v-icon>
                    <v-icon 
                      v-else
                      medium
                    >
                      filter_list
                    </v-icon>
                  </v-btn> 
                </template>
                <span>Advanced filter</span>
              </v-tooltip>
            
              <v-tooltip
                content-class="bottom"
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-avatar 
                    class="cursor-pointer"
                    v-on="on"
                    @click="loadClaims"                
                  >
                    <v-icon medium>
                      mdi-refresh
                    </v-icon>
                  </v-avatar>
                </template>
                <span>Reload</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn
                    v-if="$hasPermissionTo(['generate claim reports'])"
                    icon
                    color="teal"
                    class="ma-2"
                    :loading="reportProgressing"
                    v-on="{ ...tooltip }"
                    @click="generateClaimReport"
                  >
                    <v-icon>
                      mdi-microsoft-excel
                    </v-icon>
                  </v-btn>
                </template>
                <span>Generate report</span>
              </v-tooltip>
              <employee-claims-report-document-dialog-download
                v-if="$hasPermissionTo(['download claim supporting documents'])"
                ref="downloadDialog"
                :open="showDownloadDialog && selectedClaimRequests.length > 0"
                :claim-types="claimTypes"
                @download="saveDocuments"
                @request-open="handleOpenDialog"
                @close="showDownloadDialog = false"
              />
            </v-toolbar>

            <v-data-table
              v-model="selectedClaimRequests"
              v-validate="'required'"
              :error-messages="errors.collect('selectedClaimRequests')"
              data-vv-name="selectedClaimRequests"
              data-vv-as="employees"
              :loading="tableLoading"
              :items="claimRequests"
              :headers="headers"
              :single-expand="true"
              show-expand
              show-select
              fixed-header
              class="claim-listing"
              hide-default-footer
              disable-pagination
              height="600px"
            > 
              <template v-slot:item.detail="{ item }">
                <v-row 
                  class="ml-0"
                >
                  <v-col>
                    <v-row class="font-weight-bold">
                      {{ (item.employee.person || {}).name }}
                    </v-row>
                    <v-row>
                      {{ (item.claim_request_entries || {}).length + ' item ' }}
                    </v-row>
                  </v-col>
                </v-row>
              </template>

              <template v-slot:item.cycle="{ item }">
                <div>
                  <span>
                    {{ item.claim_cycle.start_date + ' - ' + item.claim_cycle.end_date }}
                  </span>
                </div>
              </template>

              <template v-slot:item.total_amount="{ item }">
                <div>
                  <span
                    class="font-weight-bold"
                  >
                    {{ thousandSeparator((item.total_request_amount / 100).toFixed(2)) }}
                  </span>
                </div>
              </template>

              <template v-slot:item.date="{ item }">
                <div>
                  <span>
                    {{ $moment(item.request_date).format('DD MMM YYYY') }}
                  </span>
                </div>
              </template>

              <template v-slot:item.payment_date="{ item }">
                <div>
                  <span>
                    {{ item.approval_request.latest_approval.approval_status_type_id === 200 || !item.claim_bulkpay_batch ? 'N/A' : $moment(item.claim_bulkpay_batch.payment_date).format('DD MMM YYYY') }}
                  </span>
                </div>
              </template>

              <template v-slot:item.status="{ item }">
                <span
                  :class="{ 
                    'warning--text': (
                      item.approval_request.latest_approval.approval_status_type_id === 400
                    ),
                    'green--text': (
                      item.approval_request.latest_approval.approval_status_type_id === 200 || item.approval_request.latest_approval.approval_status_type_id === 600
                    ),
                  }"
                >
                  {{ item.approval_request.latest_approval.status.name }}
                </span>
              </template>
                
              <template v-slot:item.action="{ item }">
                <div>
                  <employee-claims-approvals-dialog-list-histories
                    :claim-request="item"
                    :requester="item.employee.person"
                  />
                </div>
              </template>

              <template v-slot:expanded-item="{ headers, item }">
                <td
                  :colspan="headers.length"
                  class="px-0"
                >        
                  <v-container>          
                    <v-row>
                      <v-col cols="12">
                        <v-card class="elevation-5">
                          <v-data-table
                            :headers="entryHeaders"
                            :items="item.claim_request_entries"
                            hide-default-footer
                            disable-pagination
                          >
                            <template v-slot:item.claim_type_name="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    class="mr-1"
                                    v-on="on"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <span> {{ 'Created at ' + $moment(item.created_at).format('YYYY-MM-DD hh:mmA') }} </span>
                              </v-tooltip>
                              <span>
                                {{ item.claim_type.name }} {{ item.entitlement_date_to_deduct ? '(' + $moment(item.entitlement_date_to_deduct).format('MMM YYYY') + ')' : '' }}
                              </span>
                            </template>
                            <template v-slot:item.receipt_date="{ item }">
                              <span>
                                {{ item.receipt_date ? $moment(item.receipt_date).format('DD MMM YYYY') : '-' }}
                              </span>
                            </template>
                            <template v-slot:item.receipt_number="{ item }">
                              <span>
                                {{ item.receipt_number ? item.receipt_number : '-' }}
                              </span>
                            </template>
                            <template v-slot:item.amount="{ item }">
                              <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                  <v-icon
                                    color="hrissecondary"
                                    v-on="on"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                RM{{ thousandSeparator((item.amount / 100).toFixed(2)) }} x {{ item.quantity }} unit
                              </v-tooltip>
                              <span>
                                {{ thousandSeparator((item.total_amount / 100).toFixed(2)) }}
                              </span>
                            </template>
                            <template v-slot:item.view="{ item }">
                              <employee-claims-approvals-entries-dialog-view :claim-request-entry="item" />
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-container>
                </td>
              </template>
            </v-data-table>
            <v-divider class="ml-0 mr-0" />
            <v-alert
              v-if="(isGenerateReport || error) && selectedClaimRequests.length < 1"
              class="red--text text--lighten-1 caption"
            >
              {{ errors.first('selectedClaimRequests') ? 'Please select employee for futher action' :'' }}
            </v-alert>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog 
      v-model="confirmDialog" 
      max-width="500px"
    >
      <v-card>
        <v-card-title>
          Proceed to download?
        </v-card-title>
        <v-card-text v-html="confirmationMessage" />
        <v-card-actions>
          <v-spacer />
          <v-btn 
            text 
            :disabled="forceDownloadProgressing"
            @click="handleCancelConfirmationDialog"
          >
            Cancel
          </v-btn>
          <v-btn 
            color="hrissecondary"
            class="white--text"
            :loading="forceDownloadProgressing"
            @click="forceDownloadProgressing = true; saveDocuments(true)"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import dayjs from 'dayjs'

  const start = dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD')
  const end = dayjs().endOf('month').format('YYYY-MM-DD')

  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    components: {
      EmployeeClaimsApprovalsEntriesDialogView: () => import('@/components/employee/claims/approvals/entries/DialogView'),
      EmployeeClaimsApprovalsDialogListHistories: () => import('@/components/employee/claims/approvals/DialogListHistories'),
      EmployeeClaimsReportDocumentDialogDownload: () => import('@/components/employee/claims/report/document/DialogDownload'),
    },
    data () {
      return {      
        headers: [
          {
            text: 'Employee',
            align: 'left',
            value: 'detail',
            sortable: false,
          },
          {
            text: 'Company',
            align: 'left',
            value: 'company_employee.company.name',
            sortable: false,
          },
          {
            text: 'Claim Cycle',
            align: 'left',
            value: 'cycle',
            sortable: false,
          },
          {
            text: 'Reference No.',
            align: 'center',
            value: 'reference_number',
            sortable: false,
          },
          {
            text: 'Total (RM)',
            align: 'right',
            value: 'total_amount',
            sortable: false,
          },
          {
            text: 'Request Date',
            align: 'center',
            value: 'date',
            sortable: false,
          },
          {
            text: 'Payment Date',
            align: 'center',
            value: 'payment_date',
            sortable: false,
          },
          {
            text: 'Status',
            align: 'left',
            value: 'status',
            width: '10px',
            sortable: false,
          },
          {
            text: '',
            align: 'center',
            value: 'action',
            sortable: false,
          },
        ],
        entryHeaders: [
          {
            text: 'Claim Type',
            align: 'left',
            value: 'claim_type_name',
            sortable: false,
          },
          {
            text: 'Receipt / Transaction Date',
            align: 'center',
            value: 'receipt_date',
            sortable: false,
          },
          {
            text: 'Receipt No.',
            align: 'center',
            value: 'receipt_number',
            sortable: false,
          },
          {
            text: 'Amount (RM)',
            align: 'right',
            value: 'amount',
            sortable: false,
          },
          {
            text: '',
            align: 'center',
            value: 'view',
            sortable: false,
          },
        ],
        searchInput: '',
        loading: false,
        tableLoading: false,
        reportProgressing: false,
        claimRequests: [],
        drawer: null,
        statuses: [],
        departments: [],
        companies: [],
        selectedClaimRequests: [],
        selectedStatuses: [],
        selectedDepartments: [],
        selectedCompanies: [],
        selectedClaimTypes: [],
        selectedPolicies: [],
        jobGroupPolicies: [],
        claimTypes: [],
        dateRangeMenu: false,
        dateRange: [],
        claimCycleRangeMenu: false,
        claimCycleDateRange: [start, end],
        today: new Date().toISOString().slice(0, 10), 
        appOrg: process.env.VUE_APP_ORG,
        isGenerateReport: false,
        claimTransactionDateValidityRules: [],
        maxEndDay: 0,
        showDownloadDialog: false,
        error: '',
        downloadProgressing: false,
        forceDownloadProgressing: false,
        confirmDialog: false,
        confirmationMessage: '',
      }
    },
    computed: {
      isFiltering () {
        return !_.isEmpty(this.selectedStatuses) || !_.isEmpty(this.selectedDepartments) || !_.isEmpty(this.selectedCompanies) || 
          !_.isEmpty(this.selectedClaimTypes) || !_.isEmpty(this.dateRange) || !_.isEmpty(this.selectedPolicies)
      },
      dateRangeDisplay () {
        return this.formatRangeDisplay(this.dateRange)
      },
      claimCycleRangeDisplay () {
        return this.formatRangeDisplay(this.claimCycleDateRange)
      },
    },
    watch: {
      searchInput () {
        clearTimeout(this._searchTimerId)
        this._searchTimerId = setTimeout(() => {
          this.tableLoading = true
          this.loadClaims()
        }, 500) /* 500ms throttle */
      },
      claimCycleDateRange: {
        immediate: true,
        deep: true,
        handler (newVal) {
          if (newVal && newVal.length === 2) {
            this.loadClaims()
          }
        },
      },
      selectedCompanies (newVal) {
        const last = newVal[newVal.length - 1]

        // If last selected is 'ALL', keep only 'ALL'
        if (last === 'ALL' && newVal.length > 1) {
          // Replace with only 'ALL' after current update cycle
          this.$nextTick(() => {
            this.selectedCompanies = ['ALL']
          })
        } else if (newVal.includes('ALL') && newVal.length > 1) {
          // Remove 'ALL' if other company is selected after it
          this.$nextTick(() => {
            this.selectedCompanies = newVal.filter(id => id !== 'ALL')
          })
        }
      },
    },
    created () {
      this.loading = true

      this.loadClaims()

      Promise.all([
        this.$api.jobGroupPolicies().list('?status=[200,400,600]'),
        this.$api.claimTypes().list(),
        this.$api.hrisDepartments().list(['name'], false, true),
        this.$api.hrisCompanies().list('?organization=' + this.appOrg),
        this.$api.approvalStatus().list(),
        this.$api.claimTransactionDateValidityRules().list(),
      ])
        .then(([policy, claimType, department, company, status, dateRules]) => {
          this.jobGroupPolicies = _.orderBy(policy.data, ['name'], ['asc'])
          this.claimTypes = _.orderBy(claimType.data, ['name'], ['asc'])
          this.departments = _.orderBy(department.data, ['name'], ['asc'])
          this.companies = _.orderBy(company.data, ['name'], ['asc'])
          this.companies.unshift({ id: 'ALL', name: 'All Companies' })

          this.statuses = status.data.filter(item => {
            return item.id === 200 || item.id === 400 || item.id === 600
          })

          this.claimTransactionDateValidityRules = dateRules.data

          if (this.claimTransactionDateValidityRules.length > 0) {
            this.maxEndDay = this.claimTransactionDateValidityRules[this.claimTransactionDateValidityRules.length - 1].end_day
          }

          this.loading = false
        })
    },
    methods: {
      formatRangeDisplay (rangeArray) {
        if (Array.isArray(rangeArray) && rangeArray.length === 2) {
          const [start, end] = rangeArray
          const startFormatted = this.$moment(start).format('YYYY-MM-DD')
          const endFormatted = this.$moment(end).format('YYYY-MM-DD')

          return `${startFormatted} - ${endFormatted}`
        }
        return ''
      },
      loadClaims () {
        this.isGenerateReport = false
        this.tableLoading = true
        
        this.$api.claimReports().list(this.prepareFormData())
          .then(response => {
            this.claimRequests = response.data

            this.claimRequests = _.orderBy(response.data.map(request => {
              const requestDate = this.$moment(request.request_date, 'YYYY-MM-DD')

              let matchedCompanyEmployees = request.employee.company_employees.filter(ce => {
                const startDate = this.$moment(ce.start_date, 'YYYY-MM-DD')
                const endDate = ce.end_date ? this.$moment(ce.end_date, 'YYYY-MM-DD') : null
                const cutoffDate = this.$moment(requestDate).subtract(this.maxEndDay, 'days')

                return (
                  requestDate.isSameOrAfter(startDate) &&
                  (!endDate || requestDate.isSameOrBefore(endDate) || endDate.isSameOrAfter(cutoffDate))
                )
              })

              if (request.approval_request.latest_approval.approval_status_type_id === 200) {
                if (request.claim_request_company) {
                  matchedCompanyEmployees = matchedCompanyEmployees.filter(ce => ce.company_uid === request.claim_request_company.company_uid)
                } else {
                  if (matchedCompanyEmployees.some(ce => ce.is_active_pay_status === 1)) {
                    matchedCompanyEmployees = matchedCompanyEmployees.filter(ce => ce.is_active_pay_status === 1)
                  }
                }
              } else { // pending reimbursement and completed will have claim_bulkpay_batch
                if (request.claim_bulkpay_batch) {
                  matchedCompanyEmployees = matchedCompanyEmployees.filter(ce => ce.company_uid === request.claim_bulkpay_batch.company_uid)
                } else if (request.claim_request_company) { // special case for company that do not generate bulkpay but claim through system
                  matchedCompanyEmployees = matchedCompanyEmployees.filter(ce => ce.company_uid === request.claim_request_company.company_uid)
                }
              }

              const latestCompanyEmployee = _.maxBy(matchedCompanyEmployees, ce =>
                this.$moment(ce.created_at, 'YYYY-MM-DD').valueOf() // backend is latest company employee, so cannot use start_date
              )

              return {
                ...request,
                company_employee: latestCompanyEmployee,
              }
            }), ['reference_number'], ['desc'])

            this.tableLoading = false
          })
      },
      prepareFormData () {
        return {
          searchInput: this.searchInput,
          claimCycleDateRange: this.claimCycleDateRange,
          dateRange: this.getAllDatesInRange(),
          statuses: this.selectedStatuses,
          departments: this.selectedDepartments,
          claimTypes: this.selectedClaimTypes,
          policies: this.selectedPolicies,
          companies: this.selectedCompanies.includes('ALL') ? (
            this.companies.filter(company => {
              return company.id !== 'ALL'
            }).map(company => {
              return company.id
            })
          ) : this.selectedCompanies,
        }
      },
      clearFilter () {
        this.selectedStatuses = []
        this.selectedDepartments = []
        this.selectedPolicies = []
        this.selectedCompanies = []
        this.selectedClaimTypes = []
        this.dateRange = []
        this.loadClaims()
      },
      getAllDatesInRange () {
        const [start, end] = this.dateRange
        if (!start || !end) return []

        const startDate = this.$moment(start)
        const endDate = this.$moment(end)
        const dateList = []

        while (startDate.isSameOrBefore(endDate)) {
          dateList.push(startDate.format('YYYY-MM-DD'))
          startDate.add(1, 'day')
        }

        return dateList
      },
      thousandSeparator (amount) {
        if (amount !== '' || amount !== undefined || amount !== 0 || amount !== '0' || amount !== null) {
          return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        } else {
          return amount
        }
      },
      allowedDatesFor (rangeArray) {
        return (date) => {
          if (rangeArray && rangeArray.length === 1) {
            return date >= rangeArray[0]
          }
          return true
        }
      },
      generateClaimReport () {
        this.isGenerateReport = true

        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.reportProgressing = true

            this.$api.claimReports().generateClaimReport({ claimRequests: this.selectedClaimRequests })
              .then(res => {
                let blob = new Blob([res.data], { type: res.data.type })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Claim Report_' + this.$moment().format('YYYYMMDDHHmm') + '.xlsx') 
                link.click()
                this.reportProgressing = false

                this.$snack({ message: 'Claim report downloaded successfully' })
              })
              .catch(error => {
                this.reportProgressing = false
                if (error.response.status === 400) {
                  this.$snack({ 
                    color: 'error',
                    message: 'No record found', 
                  })
                } else {
                  this.$snack({ 
                    color: 'error', 
                    message: 'Error generating claim report',
                  })
                }
              })
            this.isGenerateReport = false
          })
      },
      saveDocuments (forceDownload = false) {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return

            this.downloadProgressing = true
            this.$refs.downloadDialog.setProgressing(true)
            const downloadFormData = this.$refs.downloadDialog.prepareFormData()

            this.$api.claimReports().downloadDocuments({ claimRequests: this.selectedClaimRequests, forceDownload: forceDownload, data: downloadFormData })
              .then(res => {
                let blob = new Blob([res.data], { type: 'application/zip' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.setAttribute('download', 'Claim Supporting Documents_' + this.$moment().format('YYYYMMDDHHmm') + '.zip') 
                link.click()
                this.$refs.downloadDialog.setProgressing(false)
                this.downloadProgressing = false
                this.forceDownloadProgressing = false
                this.confirmDialog = false
                this.showDownloadDialog = false

                this.$snack({ message: 'Claim supporting documents downloaded successfully' })
              })
              .catch(error => {
                error.response.data.text().then(text => {
                  try {
                    const json = JSON.parse(text) // Convert to object
                    const message = json.error || 'Error downloading claim supporting document'
                    let messages = []

                    if (error.response.status === 422) {
                      const msg = json.requests_without_documents.map(r =>
                        `<li>${r.employee_name} (${r.reference_number}) - ${r.company_name}</li>`
                      ).join('\n')

                      messages.push(`List of claim requests without supporting document: <ul>${msg}</ul>`)

                      this.confirmationMessage = messages.join('<br>')

                      this.confirmDialog = true
                    } else {
                      this.$snack({
                        color: 'error',
                        message: message,
                      })
                      this.$refs.downloadDialog.setProgressing(false)
                      this.downloadProgressing = false
                    }
                  } catch (e) {
                    // If it's not valid JSON
                    this.$snack({
                      color: 'error',
                      message: text || 'Error',
                    })
                    this.$refs.downloadDialog.setProgressing(false)
                    this.downloadProgressing = false
                  }
                })
              })
          })
      },
      handleOpenDialog () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              this.error = 'No claim request selected'
              return this.error
            }

            this.error = ''
            this.showDownloadDialog = true
          })
      },
      handleCancelConfirmationDialog () {
        this.downloadProgressing = false
        this.confirmDialog = false
        this.$refs.downloadDialog.setProgressing(false)
      },
    },
  }
</script>

<style scoped>
.claim-listing >>> ::-webkit-scrollbar {
  width: 3px !important; 
}

/* Track */
.claim-listing >>> ::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}
 
/* Handle */
.claim-listing >>> ::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
.claim-listing >>> ::-webkit-scrollbar-thumb:hover {
  background:  #555; 
}

::v-deep .v-toolbar__content{
  margin-left:0px !important;
}

.cursor-pointer{
  cursor: pointer;
} 
</style>
